<ng-template #template>
  <div class="svc-flex-column">
    <ng-template *ngIf="creator?.showToolbox" [component]="{ name: 'svc-toolbox', data: {model: creator} }">
    </ng-template>
  </div>
  <div class="svc-tab-designer">
    <ng-template [component]="{ name: 'survey', data: {model: survey} }">
    </ng-template>
  </div>
</ng-template>
